import type { CollectionActivity } from '@/types/collection';
import { classifyMediaType } from '@/utils/classifyMediaType';

import type { ACTIVITY_TRANSACTION_TYPE } from './constants';
import { ACTIVITY_COLUMNS_ID } from './constants';

export type ActivityDataTable = {
  id: number | string;
  thumbnail: string;
  name: string;
  type: string;
  transactionType: ACTIVITY_TRANSACTION_TYPE;
  price: string;
  quantity: number;
  from: string;
  to: string;
  time: string;
  denom: string;
  assetId: string | number;
};

export const getColumnClassNameActivity = (columnKey: React.Key) => {
  let className = '';
  if (columnKey === ACTIVITY_COLUMNS_ID.Price) className += ' text-right';
  return className;
};

export const convertToDataActivityTable = (data: CollectionActivity[]): ActivityDataTable[] => {
  return data.map((dt) => {
    return {
      id: dt.txHash,
      thumbnail: dt.asset.picture,
      name: dt.asset.name,
      type: classifyMediaType(dt.asset.mimeType),
      price: dt.price,
      quantity: dt.quantity,
      denom: dt.denom,
      time: dt.timestamp,
      from: dt.seller?.username ?? '--',
      to: dt.buyer?.username ?? '--',
      assetId: dt.tokenId,
      transactionType: dt.event as ACTIVITY_TRANSACTION_TYPE,
    };
  });
};
